<template>
    <div v-if="products && products.length > 0">
        <h2 :class="{'section-title': params.scenario !== 'home'}"
            v-if="params.scenario === 'home'">
            <span class="hidden-xs-down">
                <span v-if="$scope.CUSTOMER">{{ $scope.CUSTOMER.FIRST_NAME }},</span>
                Uma seleção pensada pra você
            </span>
            <span class="hidden-xs-up">Pensado pra você</span>
        </h2>
        <h2 class="section-title" v-else-if="params.scenario === 'product-page'">
            <i class="icon-cr icon-like"></i>Quem viu também se interessou por
        </h2>
        <ProductList
            :products="products"
            :item-options="itemOptions"
            :slider-options="sliderOptions"
            :event-name="listEventName"
            :list-class="listClass || `product-list product-list-${params.count}`"
            :shorter-image="shorterImage"
            @scroll="$emit('scroll', $event)"/>
    </div>
</template>

<script>
    import ProductListItem from "../product/ProductListItem";
    import ProductList from "./ProductList";
    import RequestsEmitter from "@bit/chicorei.chicomponents.util.requests-emitter";

    export default {
        name: "Recommendations",

        mixins: [RequestsEmitter],

        components: {ProductList, ProductListItem},

        props: {
            params: {
                type: Object,
                required: true
            },
            sliderOptions: {
                type: Object
            },
            listEventName: {
                type: String,
                required: true
            },
            itemOptions: Object,
            shorterImage: Boolean,
            listClass: String
        },

        data() {
            return {
                products: null
            }
        },

        computed: {
            innerItemOptions() {
                return {
                    displayPercent: false,
                    hideInstallments: true,
                    ...(this.itemOptions || {})
                }
            }
        },

        created() {
            this.fetchData();
        },

        methods: {
            fetchData() {
                this.exposedRequests++;
                this.axios.http.get("/recommendation.php", {params: this.params})
                    .then((response) => {
                        if (response.data.products) {
                            this.products = response.data.products.data;
                            if (this.products.length > 0) {
                                this.$emit('success');
                            }
                        }
                    })
                    .catch(error => console.error(error))
                    .then(() => this.exposedRequests--);
            },
        }
    }
</script>